export default __webpack_public_path__ + "4820ac63dd2f285eaa9e2916d0491dcd.svg";